import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const getRestrictionsFrag = `
    id
    dateFrom
    folderId
    serviceId
    person {
        ${personInfoFrag}
    }
    workData {
        ... on WorkDataMovementRestrictionObject {
            type
        }
    }
`;
